export function SectionLabel({ children }: { children: string }) {
  return (
    <div className="font-sans text-l-terracotta text-[11px] font-semibold uppercase tracking-[0.18em] mb-5 md:mb-6">
      {children}
    </div>
  );
}
